// jquery for menu close button focus 
$(document).ready(function () {
    $(document).on('click', '.wt-header__icon.wt-header__menu-trigger.wt-icon', function () {
      setTimeout(function () {
        $('.wt-drawer__close').focus();
      }, 500); // 1 second delay
    });
  });

  // shop inside opennning on hover removal and only opening on click 
// $(document).ready(function() {
//   const parentItem = $('.wt-page-nav-mega__item--parent');
//   const link = parentItem.find('.wt-page-nav-mega__link--parent');
//   const submenu = parentItem.find('.wt-page-nav-mega__sublist__wrapper');

//   // 1. Remove hover functionality completely
//   parentItem.off('mouseenter mouseleave');

//   // 2. Hide submenu initially
//   submenu.hide();

//   // 3. Toggle submenu on click or keyboard activation
//   link.on('click keydown', function(e) {
//     // Allow Enter (13) or Space (32) or mouse click
//     if (e.type === 'click' || e.keyCode === 13 || e.keyCode === 32) {
//       e.preventDefault();

//       // Toggle active/open class (optional)
//       parentItem.toggleClass('is-open');

//       // Show/hide submenu
//       submenu.slideToggle(200);

//       // Close other open menus (optional if you have multiple)
//       parentItem.siblings().removeClass('is-open').find('.wt-page-nav-mega__sublist__wrapper').slideUp(200);
//     }
//   });

//   // 4. (Optional) Close dropdown when clicking outside
//   $(document).on('click', function(e) {
//     if (!parentItem.is(e.target) && parentItem.has(e.target).length === 0) {
//       parentItem.removeClass('is-open');
//       submenu.slideUp(200);
//     }
//   });
// });


// shop now inside menu button collpase expand functionaity
$(document).ready(function () {

  function updateAriaExpanded() {
    const $ul = $(".wt-page-nav-mega__list.wt-page-nav-mega__list--center");

    $ul.find(".wt-page-nav-mega__item.wt-page-nav-mega__item--parent.wt-page-nav-mega__item--simple").each(function () {
      const $link = $(this).find(".wt-page-nav-mega__link.wt-page-nav-mega__link--parent");

      if ($link.hasClass("submenu-opened")) {
        $link.attr("aria-expanded", "true");
      } else {
        $link.attr("aria-expanded", "false");
      }
    });
  }

  // Run initially
  updateAriaExpanded();

  // Create MutationObserver
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        updateAriaExpanded();
      }
    });
  });

  // Observe all .wt-page-nav-mega__link elements inside the UL
  $(".wt-page-nav-mega__list.wt-page-nav-mega__list--center .wt-page-nav-mega__link.wt-page-nav-mega__link--parent").each(function () {
    observer.observe(this, {
      attributes: true,
      attributeFilter: ["class"] // Only watch class changes
    });
  });

});


// jquery for search button to close button focus 
$(document).on("click", ".wt-header__icon.wt-header__search-trigger.wt-icon", function () {
  setTimeout(function () {
    $(".wt-header__search__field").focus();
  }, 500); 
});
// jqauery for role button and and aria-haspopup  for search button in nav 
$(document).ready(function () {
  $('a.wt-header__nav-teaser__link.wt-header__nav-teaser__link--parent[href="/collections/all-products"]')
    .attr({
      'aria-haspopup': 'true',
      'role': 'button'
    });
});

// jquery for shop focus to close button
$(document).ready(function () {
  $('a.wt-header__nav-teaser__link.wt-header__nav-teaser__link--parent[href="/collections/all-products"]').on('click', function () {
    setTimeout(function () {
      $('.wt-drawer__close').focus();
    }, 500);
  });
});
// jquery for shop all link aria-label 
$(document).ready(function () {
  const btn = $('.hero__button--primary.hero__button--secondary.hero__button.hero');

  // Get current aria-label
  const currentLabel = btn.attr('aria-label') || '';

  // Build the new aria-label
  const newLabel = currentLabel + ' — SEA EL SKINCARE';

  // Set updated aria-label
  btn.attr('aria-label', newLabel);
});
// query for regular price aria-label
$(document).ready(function () {
  $('.price__container .price__regular').each(function () {
    const $regularPriceSpan = $(this).find('.price-item.price-item--regular.wt-product__price__final');

    if ($regularPriceSpan.length) {
      $('<span class="visually-hidden visually-hidden--inline">Regular price</span>')
        .insertBefore($regularPriceSpan);
    }
  });
});
// query for regular and sale price span
$(document).ready(function () {
  $('.price__sale.visible').each(function () {

    const $comparePrice = $(this).find('.price-item--lower.wt-product__price__compare');
    const $salePrice = $(this).find('.price-item--sale.price-item--last.wt-product__price__final');

    // Condition: only run if BOTH price elements are present
    if ($comparePrice.length && $salePrice.length) {

      // Add visually hidden text BEFORE compare price (regular price)
      if ($comparePrice.prev('.visually-hidden').length === 0) {
        $comparePrice.before('<span class="visually-hidden">Regular price</span>');
      }

      // Add visually hidden text BEFORE sale price (sale price)
      if ($salePrice.prev('.visually-hidden').length === 0) {
        $salePrice.before('<span class="visually-hidden">Sale price</span>');
      }

    }
  });
});
// jquery for wholeslale page button aria-label 
$(document).ready(function () {
  const btn = $('.hero__button--primary.block__button.block');

  // Get current aria-label
  const currentLabel = btn.attr('aria-label') || '';

  // Build the new aria-label
  const newLabel = currentLabel + ', After successful submission the form is submitted and the page will reload';

  // Set updated aria-label
  btn.attr('aria-label', newLabel);
});

// Accessibility Enhancements for Third-Party Links
// $(document).ready(function () {
//   var excludedLinks = [];
 
//   function isThirdParty(url) {
//     try {
//       var linkHost = new URL(url, window.location.origin).hostname;
//       var currentHost = window.location.hostname;
//       return linkHost && linkHost !== currentHost;
//     } catch (e) {
//       return false;
//     }
//   }
 
//   function handleExternalLinks() {
//     $("a").each(function () {
//       var $link = $(this);
//       var href = $link.attr("href");
 
//       if (!href || !isThirdParty(href) || excludedLinks.includes(href)) return;
 
//       // Always open in new tab
//       $link.attr("target", "_blank");
//       $link.attr("rel", "noopener noreferrer");
 
//       // Add aria-label only if missing
//       if (!$link.attr("aria-label")) {
//         var existingText = $.trim($link.text());
//         var ariaLabel = existingText
//           ? existingText + ", This link will open in a new tab"
//           : "This link will open in a new tab";
//         $link.attr("aria-label", ariaLabel);
//       }
 
//       // Update image alt only if missing
//       var $img = $link.find("img, svg").first();
//       if ($img.length && !$img.attr("alt")) {
//         $img.attr("alt", "This link will open in a new tab");
//       }
//     });
//   }
 
//   // Run once on load
//   handleExternalLinks();
 
//   // Re-run dynamically if DOM changes
//   var observer = new MutationObserver(function () {
//     handleExternalLinks();
//   });
//   observer.observe(document.body, { childList: true, subtree: true });
// });
// Email and phone number labels
document.addEventListener('DOMContentLoaded', () => {
  const handleContactLinks = () => {
    const links = document.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]');
 
    links.forEach(link => {
      const href = link.getAttribute('href');
      const linkText = link.textContent.trim();
 
      if (href.startsWith('mailto:')) {
        link.setAttribute('aria-label', `Email Address: ${linkText}`);
      } else if (href.startsWith('tel:')) {
        link.setAttribute('aria-label', `Phone number: ${linkText}`);
      }
    });
  };
 
  handleContactLinks();
})
// jquery for missing labels  in wholesale page
$(document).ready(function () {
  $('.shogun-form-text-input').each(function () {
    const input = $(this).find('input');
    const label = $(this).find('label');

    if (input.length && label.length) {
      const inputId = input.attr('id');
      if (inputId) {
        label.attr('for', inputId);
      }
    }
  });
});
// Accessibility Enhancements for Third-Party Links
$('a').filter('[target="_blank"]').append('<span class="visually-hidden">(This will opens in new tab)</span>');
// aria-hidden true for decorative svgs
 $(document).ready(function () {
    $('svg').each(function () {
        if (!$(this).attr('aria-hidden')) {
            $(this).attr('aria-hidden', 'true');
        }
    });
});

$('.wt-keys__image-container').attr('aria-hidden', 'true');

// converting h3 to h2 and h4 to h3 in the product description
$(document).ready(function () {

  function convertHeadings() {

    /* -------------------------
       Convert h3 → h2 (custom)
    ------------------------- */
    $(".wt-collapse__target .wt-collapse__target--text h3").each(function () {
      const $h3 = $(this);

      const newClasses = ($h3.attr("class") || "") + " custom";

      const $h2 = $("<h2>", {
        html: $h3.html(),
        class: newClasses.trim()
      });

      $h3.replaceWith($h2);
    });

    /* -------------------------
       Convert h4 → h3 (custom1)
    ------------------------- */
    $(".wt-collapse__target .wt-collapse__target--text h4").each(function () {
      const $h4 = $(this);

      const newClasses = ($h4.attr("class") || "") + " custom1";

      const $h3_new = $("<h3>", {
        html: $h4.html(),
        class: newClasses.trim()
      });

      $h4.replaceWith($h3_new);
    });

  }

  // Run initially
  convertHeadings();

  // MutationObserver → reapply if theme rewrites DOM
  const observer = new MutationObserver(function () {
    convertHeadings();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});

// expnad collapse aria-expanded toggle for product description
$(document).ready(function () {

  function updateCollapseDisplay() {
    const $section = $(".wt-collapse.wt-collapse--always.scroll-trigger.animate--slide-in.disabled-on-mobile");

    $section.each(function () {
      const $sec = $(this);
      const $trigger = $sec.find(".wt-collapse__trigger");
      const $target = $sec.find(".wt-collapse__target");

      if ($trigger.hasClass("wt-collapse__trigger--active")) {
        $target.css("display", "block");
      } else {
        $target.css("display", "none");
      }
    });
  }

  // Initial run
  updateCollapseDisplay();

  // MutationObserver to detect class changes dynamically
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        updateCollapseDisplay();
      }
    });
  });

  // Watch all triggers inside the section
  $(".wt-collapse.wt-collapse--always.scroll-trigger.animate--slide-in.disabled-on-mobile .wt-collapse__trigger")
    .each(function () {
      observer.observe(this, {
        attributes: true,
        attributeFilter: ["class"]
      });
    });

});

// Wait till DOM is ready
$(document).ready(function() {
    // Target all li elements inside the gallery
    $('[data-gallery] li').removeAttr('role').removeAttr('aria-label');
    
    const gallery = document.querySelector('[data-gallery] ul');
    if (gallery) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1 && node.tagName === 'LI') {
                        $(node).removeAttr('role').removeAttr('aria-label');
                    }
                });
            });
        });
        observer.observe(gallery, { childList: true });
    }
});



//  br tag hide
 $(document).ready(function(){
  $("br").attr("aria-hidden", "true");
});


//  hr tag hide
$(document).ready(function(){
  $("hr").attr("aria-hidden", "true");
});

// remove the tabindex query

$(document).ready(function() {
  $('.card__picture-container .card').attr('tabindex', '-1');
});

// aria-label addition 
$(document).ready(function() {
  $('.filter__header.wt-collapse__trigger').each(function() {
    // Use the visible text as the accessible name
    var labelText = $(this).text().trim();
    
    // Add aria-label if not already present
    if (!$(this).attr('aria-label')) {
      $(this).attr('aria-label', labelText + ' filter toggle');
    }
  });
});
// jquery for aria-label 

$(document).ready(function() {
  $('.noUi-handle').attr('aria-label', 'price slider');
});
 


// third party or external link warning 
$(document).ready(function () {
  var excludedLinks = [];

  function isThirdParty(url) {
    try {
      var linkHost = new URL(url, window.location.origin).hostname;
      var currentHost = window.location.hostname;
      return linkHost && linkHost !== currentHost;
    } catch (e) {
      return false;
    }
  }

  function getSiteName(url) {
    try {
      var host = new URL(url).hostname;
      host = host.replace(/^www\./, ""); // remove www.
      var parts = host.split(".");
      if (parts.length >= 2) {
        return parts[parts.length - 2].charAt(0).toUpperCase() + parts[parts.length - 2].slice(1);
      }
      return host;
    } catch (e) {
      return "External site";
    }
  }

  function handleExternalLinks() {
    $("a").each(function () {
      var $link = $(this);
      var href = $link.attr("href");

      // SKIP EXCLUDED LINKS
      if (
        !href ||
        !isThirdParty(href) ||
        excludedLinks.includes(href) ||
        href.includes("okendo.reviews") ||
        $link.hasClass("oke-w-writeReview")
      ) return;

      // Always open in new tab
      $link.attr("target", "_blank");
      $link.attr("rel", "noopener noreferrer");

      // Aria-label with site name first
      var siteName = getSiteName(href);
      $link.attr(
        "aria-label",
        `${siteName}, Redirecting to a third-party website (opens in a new tab).`
      );

      // Img or SVG alt
      var $img = $link.find("img, svg").first();
      if ($img.length && !$img.attr("alt")) {
        $img.attr(
          "alt",
          `${siteName}, Redirecting to a third-party website (opens in a new tab).`
        );
      }
    });
  }

  handleExternalLinks();

  var observer = new MutationObserver(function () {
    handleExternalLinks();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});